"use client"

import { cn } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import type { ComponentProps, ReactNode } from "react"
import {
  GachaBuybackConfirmationBody,
  type GachaBuybackConfirmationItem,
} from "../gacha-buyback-confirmation-body"
import { GachaDialogContent } from "../gacha-dialog-content"
import type { GachaPortfolioItem } from "./gacha-portfolio-items"

type GachaBuybackConfirmationDialogProps = Omit<
  ComponentProps<typeof GachaBuybackConfirmationBody>,
  "item"
> & {
  item: GachaPortfolioItem | GachaBuybackConfirmationItem
  children?: ReactNode
  className?: string
  overlayClassName?: string
}

export const GachaBuybackConfirmationDialog = reatomComponent(
  ({
    item,
    children,
    className,
    overlayClassName,
    ...props
  }: GachaBuybackConfirmationDialogProps) => (
    <GachaDialogContent
      className={cn("max-w-[440px] gap-5 p-5", className)}
      overlayClassName={overlayClassName}
      preventDismiss={props.buybackBusy}
    >
      <GachaBuybackConfirmationBody
        {...props}
        item={
          "marketValue" in item
            ? item
            : {
                image: item.image,
                name: item.name,
                collectionName: item.collection,
                marketValue: item.price,
                buybackOffer: item.buybackOffer,
              }
        }
      />
      {children}
    </GachaDialogContent>
  ),
  "GachaBuybackConfirmationDialog",
)
